// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f0797b80","703":"fd0a3f9f","787":"2d0dd038"}[chunkId] + ".chunk.js";
};